import { useQuery } from 'react-query'
import { axios } from '../../../lib'

export const loadStates = (query: any): Promise<any> => {
  return axios.get('orders/generals/states', {
    params: {
      page: 1,
      limit: 100,
      ...query
    }
  })
}

export function useLoadStates(query: any) {
  const { data, error, isLoading, isFetching, isPreviousData } = useQuery(
    ['states'],
    () => loadStates(query),
    {
      staleTime: Number.POSITIVE_INFINITY
    }
  )
  return { data, error, isLoading, isFetching, isPreviousData }
}
